// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Title.module.scss  */
.Title-module-Root_1B0 {
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--title-font-family);
  font-style: normal;
  color: var(--color-base); }

.Title-module-h1Tag_9w_ {
  font-size: var(--title-h1-font-size);
  line-height: var(--title-h1-line-height); }

.Title-module-h2Tag_2yP {
  font-size: var(--title-h2-font-size);
  line-height: var(--title-h2-line-height); }

.Title-module-h3Tag_1Y9 {
  font-size: var(--title-h3-font-size);
  line-height: var(--title-h3-line-height); }

.Title-module-h4Tag_jau {
  font-size: var(--title-h4-font-size);
  line-height: var(--title-h4-line-height); }

.Title-module-h5Tag_2G0 {
  font-size: var(--title-h5-font-size);
  line-height: var(--title-h5-line-height); }

.Title-module-h6Tag_3JG {
  font-size: var(--title-h6-font-size);
  line-height: var(--title-h6-line-height); }

.Title-module-thinWeight_1vd {
  font-weight: 200; }

.Title-module-lightWeight_28r {
  font-weight: 300; }

.Title-module-regularWeight_2Um {
  /* stylelint-disable-next-line */
  font-weight: 400; }

.Title-module-semiBoldWeight_27Q {
  font-weight: 600; }

.Title-module-boldWeight_1ak {
  /* stylelint-disable-next-line */
  font-weight: 700; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Title/Title.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB,EAAE;;AAE5B;EACE,oCAAoC;EACpC,wCAAwC,EAAE;;AAE5C;EACE,oCAAoC;EACpC,wCAAwC,EAAE;;AAE5C;EACE,oCAAoC;EACpC,wCAAwC,EAAE;;AAE5C;EACE,oCAAoC;EACpC,wCAAwC,EAAE;;AAE5C;EACE,oCAAoC;EACpC,wCAAwC,EAAE;;AAE5C;EACE,oCAAoC;EACpC,wCAAwC,EAAE;;AAE5C;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gCAAgC;EAChC,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gCAAgC;EAChC,gBAAgB,EAAE","sourcesContent":["/*  imported from Title.module.scss  */\n.Title-module-Root_1B0 {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: var(--title-font-family);\n  font-style: normal;\n  color: var(--color-base); }\n\n.Title-module-h1Tag_9w_ {\n  font-size: var(--title-h1-font-size);\n  line-height: var(--title-h1-line-height); }\n\n.Title-module-h2Tag_2yP {\n  font-size: var(--title-h2-font-size);\n  line-height: var(--title-h2-line-height); }\n\n.Title-module-h3Tag_1Y9 {\n  font-size: var(--title-h3-font-size);\n  line-height: var(--title-h3-line-height); }\n\n.Title-module-h4Tag_jau {\n  font-size: var(--title-h4-font-size);\n  line-height: var(--title-h4-line-height); }\n\n.Title-module-h5Tag_2G0 {\n  font-size: var(--title-h5-font-size);\n  line-height: var(--title-h5-line-height); }\n\n.Title-module-h6Tag_3JG {\n  font-size: var(--title-h6-font-size);\n  line-height: var(--title-h6-line-height); }\n\n.Title-module-thinWeight_1vd {\n  font-weight: 200; }\n\n.Title-module-lightWeight_28r {\n  font-weight: 300; }\n\n.Title-module-regularWeight_2Um {\n  /* stylelint-disable-next-line */\n  font-weight: 400; }\n\n.Title-module-semiBoldWeight_27Q {\n  font-weight: 600; }\n\n.Title-module-boldWeight_1ak {\n  /* stylelint-disable-next-line */\n  font-weight: 700; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
